import { Card, Typography } from 'antd';
import { PageHeader } from '@components/page-header/PageHeader';

export function UsersListPage() {
  return (
    <>
      <PageHeader
        title="Users & Roles"
        subtitle="Manage administrators, their roles, and the locations where permissions apply"
        breadcrumb={[{ label: 'Users & Roles' }]}
      />
      <div style={{ padding: 24 }}>
        <Card>
          <Typography.Text type="secondary">
            Users table will appear here. Implementation in progress.
          </Typography.Text>
        </Card>
      </div>
    </>
  );
}